import { TextSwitch } from '@/components/widgets/switch';
import { useTicketInfo } from '@/hooks/query';
import { useBetslipStore } from '@/store/betslip';
import { useTranslations } from 'next-intl';

export const ParlayTabSwitch = () => {
	const [
		betslipTab,
		setBetslipTab,
		currentMultiTickets
	] = useBetslipStore(state => [
		state.betslipTab,
		state.setBetslipTab,
		state.currentMultiTickets
	]);

	const { refetch: refetchGetTicket } = useTicketInfo(currentMultiTickets);
    
	const t = useTranslations('General');

	return (
		<TextSwitch
			list={[t('lbl_SingleBet'), t('lbl_mixparlay')]}
			selectedIndex={betslipTab === 'parlay' ? 1 : 0}
			handleClick={(index: number) => {
				refetchGetTicket();
				setBetslipTab(index === 0 ? 'single' : 'parlay')
			}}
		/>
	);
}